// English fallback keeps the complete locale contract for every shipped language.
const verificationMessages = {
    sms_daily_limit: 'You have reached today’s verification code limit. Please try again tomorrow.',
    sms_hourly_limit: 'You have reached this hour’s verification code limit. Please try again later.',
    verification_too_frequent: 'Requests are too frequent. Please try again later.',
    verification_service_unavailable: 'The verification service is temporarily unavailable. Please try again later.',
};
export default Object.freeze(verificationMessages);
